import Vue from 'vue'
import VueRouter from 'vue-router'
import Quiz from '../views/Quiz.vue'

Vue.use(VueRouter)

const appTitle = "(1) Test: Your perfect business!";

const routes = [
  {
    path: '/',
    name: 'Quiz',
    component: Quiz,
    meta: {
      title: appTitle
    }
  },
  {
    path: '/about',
    name: 'About',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/About.vue')
  }
]

const router = new VueRouter({
  mode: 'history',
  routes
})

router.beforeEach((to, from, next) => {
  document.title = to.meta.title || appTitle;
  next();
});

export default router
